import React from 'react';
import '../Styles/service-unavailable.css';

const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || null;

/**
 * Displayed ONLY when the backend returns HTTP 503 with
 * error === 'SERVICE_UNAVAILABLE' or code === 'DATABASE_UNAVAILABLE'.
 *
 * Rendered outside the Router (inside TenantProvider), so navigation
 * uses standard anchors / window APIs rather than React Router APIs.
 */
const ServiceUnavailablePage = () => {
  const handleTryAgain = () => {
    window.location.reload();
  };

  return (
    <div className="su-container">
      <header className="su-header">
        <a
          href="/"
          className="su-logo-link"
          aria-label="Go to TheSkillGenie homepage"
        >
          <span className="su-logo-text">TheSkillGenie</span>
        </a>
      </header>

      <main className="su-content" aria-labelledby="su-title">
        <div className="su-icon-wrapper" aria-hidden="true">
          <svg
            className="su-icon"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <rect x="6" y="6" width="36" height="12" rx="3" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
            <rect x="6" y="22" width="36" height="12" rx="3" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
            <circle cx="38" cy="12" r="2.5" fill="currentColor"/>
            <circle cx="32" cy="12" r="2.5" fill="currentColor"/>
            <path d="M20 40l4-4 4 4M24 36v-4" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="24" cy="42" r="1.5" fill="#EF4444"/>
          </svg>
        </div>

        <h1 id="su-title" className="su-title">
          TheSkillGenie Platform is Temporarily Unavailable
        </h1>

        <p className="su-description">
          We're currently unable to connect to our platform services. This is
          usually temporary. Please try again in a few minutes.
        </p>

        {SUPPORT_EMAIL ? (
          <p className="su-support-text">
            If the issue persists, please contact our support team at{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="su-support-link">
              {SUPPORT_EMAIL}
            </a>
            .
          </p>
        ) : (
          <p className="su-support-text">
            If the issue persists, please contact our support team.
          </p>
        )}

        <div className="su-actions" role="group" aria-label="Recovery options">
          <button
            type="button"
            className="su-btn-primary"
            onClick={handleTryAgain}
            autoFocus
          >
            Try Again
          </button>
          <a
            href="https://www.theskillgenie.com/contact"
            className="su-btn-secondary"
          >
            Support
          </a>
          <a href="/" className="su-btn-secondary">
            Go to Homepage
          </a>
        </div>
      </main>
    </div>
  );
};

export default ServiceUnavailablePage;
